import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * Flattens nested objects into a single-level object.
 * Example: { user: { name: "John", email: "john@example.com" } }
 * Becomes: { user_name: "John", user_email: "john@example.com" }
 */
const flattenObject = (obj, prefix = "") => {
  let flattened = {};
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        Object.assign(flattened, flattenObject(obj[key], `${prefix}${key}_`));
      } else {
        flattened[`${prefix}${key}`] = obj[key];
      }
    }
  }
  return flattened;
};

export const exportToExcel = (
  data,
  filePrefix = "Export",
  sheetName = "Sheet1"
) => {
  if (!data || data.length === 0) {
    toast.warning("No data available to export!");
    return;
  }

  const flattenedData = data.map((item) => flattenObject(item));

  const now = new Date();
  const formattedDateTime = now
    .toISOString()
    .replace(/T/, "_")
    .replace(/:/g, "-")
    .split(".")[0];
  const fileName = `${filePrefix}_${formattedDateTime}.xlsx`;

  const worksheet = XLSX.utils.json_to_sheet(flattenedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  XLSX.writeFile(workbook, fileName);
};
